/**
 * Depot timezone date format enum.
 *
 * Use these constants for type-safe date formatting.
 *
 * @example TypeScript
 * ```typescript
 * import { DepotTimezoneDateFormat } from './enums/depot-timezone-date-format.enum';
 * const format = DepotTimezoneDateFormat.Full;
 * ```
 *
 * @example Template (string literals work too)
 * ```html
 * {{ date | depotTimezoneDate:'full' }}
 * {{ date | depotTimezoneDate:'short' }}
 * ```
 */
export enum DepotTimezoneDateFormat {
    /** Full date and time with timezone abbreviation: "Jun 15, 2025, 10:30 AM EST" */
    Full = 'full',
    /** Short date and time: "6/15/25, 10:30 AM" */
    Short = 'short',
    /** Date only without time: "Jun 15, 2025" or "6/15/2025" */
    DateOnly = 'dateOnly',
    /** Time only with timezone abbreviation: "10:30 AM EST" */
    TimeOnly = 'timeOnly'
}
